// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgNotice24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M15.8137 4.36171C15.9349 4.53131 16 4.73453 16 4.94295V19.0566C16 19.6089 15.5523 20.0566 15 20.0566C14.7916 20.0566 14.5884 19.9914 14.4188 19.8703L9 15.9998H5C4.44772 15.9998 4 15.552 4 14.9998V8.99976C4 8.44747 4.44772 7.99976 5 7.99976H9L14.4188 4.12922C14.8682 3.80821 15.4927 3.9123 15.8137 4.36171ZM14.5 18.0849V5.91287L9.4807 9.49976L5.5 9.49887V14.4989L9.4807 14.4998L14.5 18.0849ZM20.0303 6.96943C19.7374 6.67654 19.2626 6.67654 18.9697 6.96943L17.5555 8.38364C17.2626 8.67654 17.2626 9.15141 17.5555 9.4443C17.8483 9.7372 18.3232 9.7372 18.6161 9.4443L20.0303 8.03009C20.3232 7.7372 20.3232 7.26232 20.0303 6.96943ZM18.9697 17.1514C19.2626 17.4443 19.7374 17.4443 20.0303 17.1514C20.3232 16.8585 20.3232 16.3836 20.0303 16.0907L18.6161 14.6765C18.3232 14.3836 17.8483 14.3836 17.5555 14.6765C17.2626 14.9694 17.2626 15.4443 17.5555 15.7372L18.9697 17.1514ZM22.3107 12.0604C22.3107 12.4746 21.9749 12.8104 21.5607 12.8104H18.5607C18.1464 12.8104 17.8107 12.4746 17.8107 12.0604C17.8107 11.6462 18.1464 11.3104 18.5607 11.3104H21.5607C21.9749 11.3104 22.3107 11.6462 22.3107 12.0604Z"
				/>
			</Svg>
		);
	}
);
SvgNotice24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgNotice24;
